import { useEffect } from 'react';

export default function AntiCopyProtection() {
  useEffect(() => {
    // Disable right-click
    const disableRightClick = (e) => {
      e.preventDefault();
      showWarning('Sağ tık menüsü devre dışı bırakıldı! 🚫');
      return false;
    };

    // Disable keyboard shortcuts
    const disableShortcuts = (e) => {
      // Ctrl+C, Ctrl+A, Ctrl+X, Ctrl+S, Ctrl+P
      if ((e.ctrlKey || e.metaKey) && ['c', 'a', 'x', 's', 'p'].includes(e.key.toLowerCase())) {
        e.preventDefault();
        showWarning('Kopyalama devre dışı! 🚫');
        return false;
      }

      // F12, Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+U
      if (
        e.key === 'F12' ||
        ((e.ctrlKey || e.metaKey) && e.shiftKey && ['i', 'j', 'c'].includes(e.key.toLowerCase())) ||
        ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'u')
      ) {
        e.preventDefault();
        showWarning('Geliştirici araçları devre dışı! 🚫');
        return false;
      }

      // Print Screen
      if (e.key === 'PrintScreen') {
        showWarning('⚠️ Ekran görüntüsü tespit edildi! Bu içerik korunmaktadır.');
        return false;
      }
    };

    // Disable text selection
    const disableSelection = (e) => {
      // Check if target is a DOM element and has closest method
      if (e.target && e.target.closest && e.target.closest('.protected-content')) {
        e.preventDefault();
        return false;
      }
    };

    // Disable copy
    const disableCopy = (e) => {
      // Only prevent copy if target is within protected content
      if (e.target && e.target.closest && e.target.closest('.protected-content')) {
        e.preventDefault();
        showWarning('İçerik kopyalanamaz! 🚫');
        return false;
      }
    };

    // Disable drag
    const disableDrag = (e) => {
      // Check if target is a DOM element and has closest method
      if (e.target && e.target.closest && e.target.closest('.protected-content')) {
        e.preventDefault();
        return false;
      }
    };

    // DevTools detection
    let devtoolsOpen = false;
    const detectDevTools = () => {
      const threshold = 160;
      const widthThreshold = window.outerWidth - window.innerWidth > threshold;
      const heightThreshold = window.outerHeight - window.innerHeight > threshold;
      
      if (widthThreshold || heightThreshold) {
        if (!devtoolsOpen) {
          devtoolsOpen = true;
          document.body.classList.add('devtools-open');
          showWarning('⚠️ Geliştirici araçları tespit edildi! İçerik korunmaktadır.');
        }
      } else {
        if (devtoolsOpen) {
          devtoolsOpen = false;
          document.body.classList.remove('devtools-open');
        }
      }
    };

    // Show warning toast
    const showWarning = (message) => {
      // Remove existing warning
      const existing = document.getElementById('copy-warning-toast');
      if (existing) {
        existing.remove();
      }

      // Create warning toast
      const toast = document.createElement('div');
      toast.id = 'copy-warning-toast';
      toast.innerHTML = message;
      toast.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        background: linear-gradient(135deg, #ef4444, #dc2626);
        color: white;
        padding: 16px 24px;
        border-radius: 12px;
        box-shadow: 0 10px 25px rgba(0,0,0,0.3);
        z-index: 99999;
        font-weight: 600;
        font-size: 14px;
        animation: slideIn 0.3s ease-out;
      `;

      // Add animation
      const style = document.createElement('style');
      style.innerHTML = `
        @keyframes slideIn {
          from {
            transform: translateX(400px);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
      `;
      document.head.appendChild(style);

      document.body.appendChild(toast);

      // Remove after 3 seconds
      setTimeout(() => {
        toast.style.animation = 'slideIn 0.3s ease-out reverse';
        setTimeout(() => toast.remove(), 300);
      }, 3000);
    };

    // Add event listeners
    document.addEventListener('contextmenu', disableRightClick);
    document.addEventListener('keydown', disableShortcuts);
    document.addEventListener('selectstart', disableSelection);
    document.addEventListener('copy', disableCopy);
    document.addEventListener('cut', disableCopy);
    document.addEventListener('dragstart', disableDrag);

    // DevTools detection interval
    const devToolsInterval = setInterval(detectDevTools, 1000);

    // Disable print
    window.addEventListener('beforeprint', (e) => {
      showWarning('⚠️ Yazdırma devre dışı!');
      e.preventDefault();
      return false;
    });

    // Cleanup
    return () => {
      document.removeEventListener('contextmenu', disableRightClick);
      document.removeEventListener('keydown', disableShortcuts);
      document.removeEventListener('selectstart', disableSelection);
      document.removeEventListener('copy', disableCopy);
      document.removeEventListener('cut', disableCopy);
      document.removeEventListener('dragstart', disableDrag);
      clearInterval(devToolsInterval);
    };
  }, []);

  return null; // This component doesn't render anything
}
